import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ClickOutsideHolder from 'components/ClickOutsideHolder';

const normalizeValue = (value) => {
	if (!value) {
		return [];
	}

	 return typeof value === 'string' ? value.split('|') : Array.isArray(value) ? value : [value];
};

class ComboBoxMultipleCheckbox extends Component {
	constructor(props) {
		super(props);
	}

	state = {
		showOptions: false,
		searchValue: '',
		options: [],
	};

	componentDidMount() {
		const { input, loadOptions } = this.props;

		if (loadOptions && input.value && !this.options?.length) {
			loadOptions().then((options) => {
				this.setState({ options });
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		  const { input } = this.props;

		if (input?.value !== prevProps?.input?.value && typeof input?.value === 'string') {
			const normalized = normalizeValue(input.value);

			// input.onChange(normalized);
		}

		if (!prevState.showOptions && this.state.showOptions) {
			const selectOptions = document.querySelector('.optionsWrapper');

			if (selectOptions.scrollIntoViewIfNeeded) {
				selectOptions.scrollIntoViewIfNeeded(false);
			} else {
				selectOptions.scrollIntoView(false);
			}
		}
	};

	getLabel = (value) => {
		const option = this.options.find(option => String(option.value) === String(value));
		return option && option.label;
	};

	get values() {
		const { input } = this.props;

		return normalizeValue(input?.value);
	}

	handleChange = (event, option) => {
		const { input } = this.props;

		const newValue = [...this.values];

		if (event.target.checked) {
			newValue.push(option);
		} else {
			const index = newValue.findIndex((value) => String(value) === String(option));
			if (index > -1) {
				newValue.splice(index, 1);
			}
		}

		input.onChange(newValue);
	};

	toggleOptions = () => {
		const { disabled, input, loadOptions } = this.props;

		if (!disabled) {
			if (this.state.showOptions) {
				input.onBlur();
			} else {
				input.onFocus();
			}

			if (typeof loadOptions === 'function') {
				loadOptions().then((options) => {
					this.setState({ options });
				});
			}

			this.setState(prevState => ({ showOptions: !prevState.showOptions }));
		}
	};

	hideOptions = () => {
		if (this.state.showOptions) {
			this.props.input.onBlur();
			this.setState({ showOptions: false });
		}

		const { input: { value, name }, submitComboboxMulty, submitOnBlur, meta } = this.props;

		if (submitOnBlur && meta.touched) {
			submitComboboxMulty(value, name);
		}
	};

	get options() {
		const { options, loadOptions } = this.props;
		return (loadOptions ? this.state.options : options) || [];
	}

	renderCheckboxGroup = () => {
		const { input, disabled } = this.props;
		const { searchValue } = this.state;

		const _options = searchValue
			? this.options.filter((option) => option.label.toLowerCase().includes(searchValue.toLowerCase()))
			: this.options;

		const values = this.values;

		return (
			<div className="optionsWrapper">
				<div className="search-input">
					<input
						checked={input.value.length === this.options.length}
						placeholder="Пошук"
						onChange={(event) => this.handleInputSearch(event)}
					/>

					<i className="icon-search2" />
				</div>

				<div className="checkbox select-all">
					<label htmlFor="ComboBox-selectAll">
						<input
							type="checkbox"
							id="ComboBox-selectAll"
							checked={values.length === this.options.length} // prev input.value.length === this.options.length
							disabled={disabled}
							onChange={(event) => this.selectAll(event)}
						/>

						<span className="checkbox-text">Вибрати все</span>
					</label>
				</div>

				{_options.map((option, index) => (
					<div className="checkbox" key={index}>
						<label htmlFor={option.value}>
							<input
								type="checkbox"
								name={`${input.label}[${index}]`}
								id={option.value}
								checked={values.some((value) => String(value) === String(option.value))}
								disabled={disabled}
								onChange={(event) => this.handleChange(event, option.value)}
							/>

							<span className="checkbox-text">{option.label}</span>
						</label>
					</div>
				))}
			</div>
		);
	};

	renderOption = (item, index, arr) => {
		if (this.options.some(option => String(option.value) === String(item))) {
			return (
				<span key={index} className="input-value">
					{this.getLabel(item)}
					{arr.length > 1 && index !== arr.length - 1 && ', '}
					{' '}
				</span>
			);
		}

		return null;
	};

	handleInputSearch = (event) => {
		const value = event.target.value;
		this.setState({ searchValue: value });
	};

	selectAll = (event) => {
		const { input } = this.props;

		const newValue = event.target.checked
			? this.options.map(option => option.value)
			: [];

		input.onChange(newValue);
	};

	render() {
		const { meta, input, placeholder, disabled } = this.props;

		const wrapperClassName = cx('input-element comboBox-multi-checkbox', {
			'isOpen': this.state.showOptions,
			'disabled': disabled,
		});

		const buttonClassName = cx('input-field', {
			'input-field__error': meta && meta.touched && meta.error,
		});

		return (
			<ClickOutsideHolder className={wrapperClassName} onClickOutside={this.hideOptions}>
				<button
					className={buttonClassName}
					type="button"
					onClick={this.toggleOptions}
				>
					{Array.isArray(this.values) ? this.values.map(this.renderOption) : placeholder}
				</button>

				{this.state.showOptions && this.renderCheckboxGroup()}
			</ClickOutsideHolder>
		);
	}
}

ComboBoxMultipleCheckbox.propTypes = {
	options: PropTypes.array.isRequired,
	input: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	error: PropTypes.object,
	meta: PropTypes.shape({
		error: PropTypes.string,
		label: PropTypes.string,
		touched: PropTypes.bool,
	}).isRequired,
};

export default ComboBoxMultipleCheckbox;
